export default __webpack_public_path__ + "static/media/docker.940725fa.png";